//@ts-nocheck
import { useEffect, useState } from 'react';
import { Button, Paper, InputBase, IconButton, TextField } from '@mui/material';
import { IconExport, IconSearch } from '../../../icons/Icon';
import styles from './ExceptionalMenuRequisition.module.scss';
import InfoModal from '../../../components/commonComponent/InfoModal';
import { toast } from 'react-toastify';
import ListData from './ListData';
import { AppDispatch, RootState } from '../../../store/store';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { BASE_URL } from '../../../constants/apiConstants';
import axiosInstance from '../../../api/axios';
import useDebounce from '../../../hooks/useDebounce';
import Loader from '../../../components/loader/Loader';
import { setExMenuRequisitionParams } from '../../../services/exceptionalMenuRequistionSliceParam';
import { format } from 'date-fns';
import * as XLSX from 'xlsx-js-style';
import { dateFormatStandard } from '../../../utils/format';
import { headerStyle, contentStyle, sectionStyle, daypartStyle, subContentStyle, categoryStyle, titleStyle } from '../../../utils/constants';
import { updateRevenuePerDay } from '../../../services/exmenuprojectionslice';
import { applyXlsxSheetStyles } from '../../../utils/helper';


const ExceptionalMenuRequisitionDetails = () => {
  const { exmenuRequisition, loading: reduxLoading, ishybrid } = useSelector((state: RootState) => state.exmenuRequisition);
  const dispatch = useDispatch<AppDispatch>();
  const { params, disableRequisition } = useSelector((state: RootState) => state.ExMenuRequisitionParams);
  const { revenuePerDay } = useSelector((state: RootState) => state?.exmenuRequisition?.revenueInfo || {});
  const [openIndices, setOpenIndices] = useState<number[]>([0]);
  const [openPublishModal, setOpenPublishModal] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [updatedRevenuePerDay, setUpdatedRevenuePerDay] = useState<number | null>(revenuePerDay || null);
  // display-only formatted string (Indian grouping, two decimals)
  const [updatedRevenueDisplay, setUpdatedRevenueDisplay] = useState<string>('');
  // Keep a local snapshot of edited rows from child tables, keyed by daypartcode
  const [localDaypartRows, setLocalDaypartRows] = useState<Record<string, any[]>>({});

  const debouncedSearch = useDebounce(searchTerm, 800);
  const debouncedRevenue = useDebounce(updatedRevenuePerDay, 1000);
  const [originalRevenueValue, setOriginalRevenueValue] = useState<number | null>(revenuePerDay || null);
  const [hasInitialized, setHasInitialized] = useState(false);
  const userId = localStorage.getItem("userid");
  
  // Helper to format numbers for display using Indian grouping (suitable for ₹)
  const formatCurrencyForDisplay = (value: any) => {
    if (value === null || value === undefined || value === '') return '';
    const num = Number(value);
    if (isNaN(num)) return value;
    return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  
  const payload = {
    userid: localStorage.getItem("userid"),
    deliverydate: params.deliverydate,
    sitecode: params.sitecode,
    cafecodelist: params.cafecodelist,
    requesttypeid: params.requesttypeid,
    searchtext: ""
  };

  // Initialize revenue per day from redux state
  useEffect(() => {
    if (revenuePerDay !== null && revenuePerDay !== undefined) {
      setUpdatedRevenuePerDay(revenuePerDay);
  // initialize formatted display
  setUpdatedRevenueDisplay(formatCurrencyForDisplay(revenuePerDay));
  setOriginalRevenueValue(revenuePerDay);
  setHasInitialized(true);
    }
  }, [revenuePerDay, params.sitecode]); // Add sitecode dependency to reset when site changes

  // Reset hasInitialized flag when site changes
  useEffect(() => {
    setHasInitialized(false);
  }, [params.sitecode]);

  // Handle revenue per day change with debounce
  const handleChangeRevenue = async (revenue) => {   
    if (params?.deliverydate && params?.sitecode && revenue !== revenuePerDay) {
      const payload = {
        deliverydate: params.deliverydate,
        sitecode: params.sitecode,
        revenueperday: revenue === "" || revenue === null || revenue === undefined ? 0 : Number(revenue),
        userid: userId,
        useridvalue: 0,
      };      
      try {
        await axiosInstance.post(
          `${BASE_URL}/api/v1/ExceptionalMenuRequisition/SaveEMRRevenuePerDay`,
          payload
        );
        dispatch(updateRevenuePerDay(revenue === "" || revenue === null || revenue === undefined ? 0 : Number(revenue)));
        // update original value after successful save
        setOriginalRevenueValue(revenue === "" || revenue === null || revenue === undefined ? 0 : Number(revenue));
      } catch (error) {
        console.error("Something went wrong:", error);
      }
    }
  };

  // Remove automatic debounced save — persist on blur only (match MR behavior)

  // Toggle individual accordion sections
  const handleToggle = (index: number) => {
    setOpenIndices(prevIndices =>
      prevIndices.includes(index) ? prevIndices.filter(i => i !== index) : [index]
    );
  };
  // Expand all sections
  const handleExpandAll = () => {
    setOpenIndices([0, 1, 2, 3, 4]);
  };

  // Collapse all sections
  const handleCollapseAll = () => {
    setOpenIndices([]); // 
  };

  const handleSubmit = async () => {
    // Check if Revenue Per Day is mandatory for Event request type
    // if (params?.requesttype === "Event" && (!revenuePerDay || revenuePerDay === 0)) {
    //   setOpenPublishModal(prev => !prev);
    //   toast("Please enter revenue per day before submitting.", { type: "warning" });
    //   return false;
    // }
 const payload1 = {
              deliverydate: params.deliverydate,
              userid: userId,
              sitecode: params.sitecode,
              pagename: "EMR",
              cafeidlist: params.cafecodelist
            };
         const res = await axiosInstance.post(
              `${BASE_URL}/api/v1/MenuRequisition/CheckIsRevenueRequired`,
              payload1
            );           
    // Check if Revenue Per Day is mandatory for Event request type
    if (params?.requesttype === "Event" && (!revenuePerDay || revenuePerDay === 0) && res?.data?.data?.isrevenuerequired!== false) {
      setOpenPublishModal(prev => !prev);
      toast("Please enter revenue per day before submitting.", { type: "warning" });
      return false;
    }


    // "return false if any custom dish name of other exist with 
    // Use localDaypartRows (UI snapshot) when available, otherwise fall back to redux state.
    // Also include any flattened UI rows to be robust against key mismatches.
    const daypartList = exmenuRequisition.exceptionalmenurequisitiondaypartlist || [];
    const flattenedLocalRows = Object.values(localDaypartRows).flat();

    const emptyOtherDishCustom = daypartList.some(daypart =>
      (localDaypartRows[daypart.daypartcode] || daypart.exceptionalmenurequisitiondeatilslist).some(dish => {
        const isOther = (dish.dishcode && dish.dishcode === 'DSH-OTHER') || (dish.dishname && String(dish.dishname).trim().toLowerCase() === 'other');
        return isOther && (!dish.customdishname || String(dish.customdishname).trim() === '');
      })
    ) || flattenedLocalRows.some((dish: any) => {
      const isOther = (dish?.dishcode && dish.dishcode === 'DSH-OTHER') || (dish?.dishname && String(dish.dishname).trim().toLowerCase() === 'other');
      return isOther && (!dish?.customdishname || String(dish?.customdishname).trim() === '');
    });

    if (emptyOtherDishCustom) {
      setOpenPublishModal(prev => !prev);
      toast("Other Dish Name (Custom) can't be empty", { type: "warning" });
      return false;
    }
    
    // "return false if any portion variant exist with 
    const emptyPortionVariantCheck = exmenuRequisition.exceptionalmenurequisitiondaypartlist.some(daypart =>
      (localDaypartRows[daypart.daypartcode] || daypart.exceptionalmenurequisitiondeatilslist).some(dish => dish.dishname && String(dish.dishname).trim() !== '' && !dish.portionvariant)
    );

    if (emptyPortionVariantCheck) {
      setOpenPublishModal(prev => !prev);
      toast("Portion Variant can't be empty", { type: "warning" });
      return false;
    }

    // "return false if any UOM exist with 
    const emptyUOMCheck = exmenuRequisition.exceptionalmenurequisitiondaypartlist.some(daypart =>
      (localDaypartRows[daypart.daypartcode] || daypart.exceptionalmenurequisitiondeatilslist).some(dish => dish.dishname && String(dish.dishname).trim() !== '' && (dish.uomcode == "" || !dish.uomcode))
    );

    if (emptyUOMCheck) {
      setOpenPublishModal(prev => !prev);
      toast("UOM can't be empty", { type: "warning" });
      return false;
    }

    // "return false if any Required From is empty" — only validate when site is hybrid (CPU + OnSite)
    if(ishybrid) {
    const missingRequiredFrom = exmenuRequisition.exceptionalmenurequisitiondaypartlist.some(daypart =>
      (localDaypartRows[daypart.daypartcode] || daypart.exceptionalmenurequisitiondeatilslist).some(dish => dish.dishcode && (!dish.requiredfrom || dish.requiredfrom === ""))
    );

    if (missingRequiredFrom) {
      setOpenPublishModal(prev => !prev);
      toast("Please select Required From before submitting.", { type: "warning" });
      return false;
    }
  }

    // "return false if any dish exist with 
    const emptyWeightPerPcCheck = exmenuRequisition.exceptionalmenurequisitiondaypartlist.some(daypart =>
      (localDaypartRows[daypart.daypartcode] || daypart.exceptionalmenurequisitiondeatilslist).some(dish => dish.dishname && String(dish.dishname).trim() !== '' && dish.uomcode === "UOM-00003" && (dish.weightpiece === 0 || dish.weightpiece === undefined || dish.weightpiece === null))
    );

    if (emptyWeightPerPcCheck) {
      setOpenPublishModal(prev => !prev);
      toast("Weight per pc can't be empty for Pcs UOM", { type: "warning" });
      return false;
    }


    setOpenPublishModal((prev) => !prev);
    setLoading(true)
    try {
      await axiosInstance.post(`${BASE_URL}/api/v1/ExceptionalMenuRequisition/SubmitExceptionalMenuRequisition`, payload);
      toast("Exceptional Menu Requisition submitted successfully", { type: "success" });
    } catch (err: any) {
      console.log("Error publishing Exceptional Menu Requisition", err);
      err?.status === 400 ?
        toast("No data available to submit", { type: "info" }) :
        toast("Unable to submit Exceptional Menu Requisition", { type: "error" });
    }
    setLoading(false)
  };

  const handleSearchDishItem = (searchtext: string) => {
    const payloadWithSearchText = { ...payload }; // assign stored params
    if (searchtext?.trim().toLowerCase().length > 2) {
      payloadWithSearchText.searchtext = searchtext?.trim().toLowerCase();
    }
    dispatch(setExMenuRequisitionParams({ ...params, searchtext: searchtext.trim().toLowerCase() }));
  }

  useEffect(() => {
    if (debouncedSearch !== null) {
      handleSearchDishItem(debouncedSearch);
    }
  }, [debouncedSearch]);

  function getQtyAndPaxArray(data: any) {
    return data?.exceptionalmenurequisitioncafedetailslist?.flatMap((cafe: any) => [
      cafe.pax === 0 ? "" : cafe.pax,
      cafe.quantity === 0 ? "" : `${cafe?.quantity} ${data?.uomcode === 'UOM-00003' ? 'Pcs' : 'Kg'}`
    ])
  }

  function getCafeNames(data: any) {
    return data?.exceptionalmenurequisitioncafedetailslist?.map((cafe: any) => cafe.cafename);
  }

  const getReportData = (ExceptionalExportData: any, mergedCellsRow, mergedRowIndex: any, startingIndex: any, maxWidth: any, rowIndexes: any) => {
    let excelData = [
      ...[['']],
    ]
    mergedRowIndex += 1
    startingIndex++;
    ExceptionalExportData?.data?.exceptionalmenurequisitiondaypartlist.map((daypart: any) => {
      if (daypart?.exceptionalmenurequisitiondeatilslist?.length > 0) {
        const cafesHeader = daypart?.exceptionalmenurequisitiondeatilslist[0] ? getCafeNames(daypart?.exceptionalmenurequisitiondeatilslist[0]) : []
        const columnHeaders = [["Dish Name", "Dish Name(Custom)", "Required From", "Portion Variant", "UOM", "Wt./Pc(gms)", ...cafesHeader?.flat()?.flatMap((item: any) => [item, ""]), "Remarks"]]
        maxWidth.push(columnHeaders[0]?.length)
        let fileLength = columnHeaders[0]?.length
        excelData = [
          ...excelData,
          ...[[`${daypart?.daypartname}`, ...Array(fileLength - 1).fill('')]],
        ]
        startingIndex++;
        rowIndexes.push({
          index: startingIndex,
          style: 'daypart'
        })
        mergedRowIndex += 1
        mergedRowIndex += 1
        const columnSubheader = [["", "", "", "", "", "", ...Array.from({ length: cafesHeader?.length }, () => ["Pax", "Req.Qty(Kg/Pcs)"]).flat(), ""]]
        excelData = [
          ...excelData,
          ...columnHeaders,
          ...columnSubheader
        ]
        rowIndexes.push({
          index: startingIndex + 1,
          style: 'header'
        })
        rowIndexes.push({
          index: startingIndex + 2,
          style: 'header'
        })
        startingIndex += 2;
        mergedCellsRow.push({ mergedRowIndex, cafes: cafesHeader?.length })
        mergedRowIndex += 1
        daypart?.exceptionalmenurequisitiondeatilslist?.map((dish) => {
          if (dish?.dishname) {
            const dishRow = [
              [
                dish?.dishname,
                dish?.customdishname ?? '',
                dish?.requiredfrom ?? '',
                dish?.portionvariant,
                dish?.uomcode === 'UOM-00003' ? 'Pcs' : dish?.uomcode === 'UOM-00004' ? 'gms' : "",
                dish?.weightpiece,
                ...getQtyAndPaxArray(dish),
                dish?.remarks
              ]
            ];
            excelData = [
              ...excelData,
              ...dishRow
            ];
            startingIndex++;
          }
        });

        mergedRowIndex = mergedRowIndex + daypart?.exceptionalmenurequisitiondeatilslist?.length
        excelData = [
          ...excelData,
          ...[[]],

        ]
        startingIndex += 1;
        mergedRowIndex += 1;
      }
    })
    return excelData;
  }

  const handleExport = async () => {
    try {
      setLoading(true)
      const res = await axiosInstance.post(`${BASE_URL}/api/v1/ExceptionalMenuRequisition/ExportExceptionalMenuRequisition`, payload);
      if (res && res?.data?.data?.exceptionalmenurequisitiondaypartlist?.length > 0) {
        const ExceptionalExportData = res?.data
        let mergedCellsRow = []
        let mergedRowIndex = 0
        let startingIndex = 0;
        let maxWidth = []
        let rowIndexes = [{
          index: startingIndex,
          style: 'title'
        }]
        const dateText = ExceptionalExportData?.data?.deliverydate
          ? `Date: ${format(new Date(ExceptionalExportData?.data?.deliverydate), 'dd MMM yyyy')}`
          : 'No Date';
        const revenueText = ExceptionalExportData?.data?.revenueperday
          ? `Revenue per day: ₹${ExceptionalExportData?.data?.revenueperday}`
          : '';
        const dateHeader = [[`${dateText}${revenueText ? `    ${revenueText}` : ''}`]]
        let exportData: any = [];
        mergedRowIndex += 1
        startingIndex += 1
        const combinedData = getReportData(ExceptionalExportData, mergedCellsRow, mergedRowIndex, startingIndex, maxWidth, rowIndexes)
        if (combinedData?.length > 1) {
          const header = [[`Exceptional Menu Requisition for ${params?.sitename}`, ...Array(maxWidth[0] - 1).fill('')]]
          exportData = [
            ...exportData,
            ...header,
            ...dateHeader,
            ...combinedData
          ]
          // Create a new workbook and worksheet
          const workbook = XLSX.utils.book_new();
          const worksheet = XLSX.utils.aoa_to_sheet(exportData);
          const totalCols = Math.max(maxWidth[0] || 0, 8);
          const columns = Array.from({ length: totalCols }, () => ({ wch: 14 }));
          columns[0] = { wch: 24 }; // Dish Name
          if (columns[1]) columns[1] = { wch: 26 }; // Dish Name(Custom)
          if (columns[2]) columns[2] = { wch: 16 }; // Required From
          if (columns[3]) columns[3] = { wch: 20 }; // Portion Variant
          if (columns[4]) columns[4] = { wch: 10 }; // UOM
          if (columns[5]) columns[5] = { wch: 12 }; // Wt./Pc(gms)
          if (columns[totalCols - 1]) columns[totalCols - 1] = { wch: 24 }; // Remarks
          worksheet['!cols'] = columns;
          rowIndexes?.forEach((rowIndex => {
            // Apply the header style to all header cells
            for (let colIndex = 0; colIndex < totalCols; colIndex++) {
              const cellAddress = XLSX.utils.encode_cell({ r: rowIndex?.index, c: colIndex });
              if (!worksheet[cellAddress]) {
                worksheet[cellAddress] = {};
              }
              switch (rowIndex?.style) {
                case 'title':
                  worksheet[cellAddress].s = titleStyle;
                  break;
                case 'header':
                  worksheet[cellAddress].s = headerStyle;
                  break;
                case 'section':
                  worksheet[cellAddress].s = sectionStyle;
                  break;
                case 'content':
                  worksheet[cellAddress].s = contentStyle;
                  break;
                case 'daypart':
                  worksheet[cellAddress].s = daypartStyle;
                  break;
                case 'subContent':
                  worksheet[cellAddress].s = subContentStyle;
                  break;
                case 'category':
                  worksheet[cellAddress].s = categoryStyle;
                  break;
                default:
                  break;
              }
            }
          }))
          let mergedCells = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } }
          ]
          mergedCellsRow.forEach(row => {
            const numberOfCafes = (row?.cafes * 2) + 5
            for (let i = 5; i < numberOfCafes; i += 2) {
              mergedCells.push({ s: { r: row?.mergedRowIndex, c: i }, e: { r: row?.mergedRowIndex, c: i + 1 } })
            }
          })
          worksheet["!merges"] = mergedCells
          applyXlsxSheetStyles(worksheet, rowIndexes, exportData.length, totalCols);

          // Alignment rule: Dish Name and Remarks left, all other header/data cells centered
          const remarksColIndex = totalCols - 1;
          for (let rowIndex = 2; rowIndex < exportData.length; rowIndex++) {
            const rowData = Array.isArray(exportData[rowIndex]) ? exportData[rowIndex] : [];
            const rowDataLength = rowData.length;
            for (let colIndex = 0; colIndex < rowDataLength && colIndex < totalCols; colIndex++) {
              const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
              if (!worksheet[cellAddress]) continue;
              if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};

              const isDishOrRemarks = colIndex === 0 || colIndex === remarksColIndex;
              worksheet[cellAddress].s = {
                ...worksheet[cellAddress].s,
                alignment: {
                  horizontal: isDishOrRemarks ? 'left' : 'center',
                  vertical: 'center'
                }
              };
            }
          }

          XLSX.utils.book_append_sheet(workbook, worksheet, "Exceptional Menu Requisition");
          // Export the workbook to an Excel file
          XLSX.writeFile(workbook, `Exceptional_Menu_Requisition-${params?.sitename}-${dateFormatStandard(params.deliverydate)}.xlsx`);
          toast("File downloaded successfully!", { type: "success" });
        } else {
          toast("No data is available", { type: "info" });
        }
        setLoading(false)
      } else {
        toast("No data is available", { type: "info" });
        setLoading(false)
      }
    } catch (err) {
      if (err === "") {
        toast("No data is available", { type: "info" });
      } else {
        toast("Some error has occured", { type: "error" });
      }
      setLoading(false)
    }
  }

  return (
    exmenuRequisition &&
    <div className="white-box mb-12">
      <div className="flex justify-content-between align-items-center title-button-wrapper mb-8">
        <div className="flex align-items-center">
          <Paper component="form" className={`search-input mr-12 ${styles.search}`}>
            <InputBase placeholder="Search Dishes/Items" value={searchTerm} onChange={(e) => setSearchTerm(e?.target?.value)} onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()} />
            <IconButton type="button" aria-label="search">
              <IconSearch />
            </IconButton>
          </Paper>
        </div>
        <div className={`button-wrap flex align-items-center ${params?.requesttype === "Event" ? styles.buttonWrapWithRevenue : ""}`}>
          {params?.requesttype === "Event" && (
            <div className={`input-wrap mr-24 ${styles.inputWrap}`}>
              <label className={`${styles.label}`}>
                Revenue Per Day <span>*</span>
              </label>
              <div className={`${styles['input-container']}`}>
                <TextField
                  className="price-input"
                  id="outlined"
                  disabled={disableRequisition}
                  value={updatedRevenueDisplay}
                  placeholder={""}
                  autoComplete="off"
                  name="disable-revenue-autofill"
                  onFocus={() => {
                    // store the original numeric value and show raw number for editing
                    setOriginalRevenueValue(updatedRevenuePerDay);
                    setUpdatedRevenueDisplay(updatedRevenuePerDay !== null && updatedRevenuePerDay !== undefined ? String(updatedRevenuePerDay) : '');
                  }}
                  onBlur={async () => {
                    // format display on blur
                    setUpdatedRevenueDisplay(formatCurrencyForDisplay(updatedRevenuePerDay));
                    // call API only if user changed the numeric value
                    if (originalRevenueValue !== updatedRevenuePerDay) {
                      await handleChangeRevenue(updatedRevenuePerDay);
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    // allow empty or numbers with up to 2 decimals while editing
                    if (value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
                      setUpdatedRevenueDisplay(value);
                      setUpdatedRevenuePerDay(value === "" ? null : Number(value));
                    }
                  }}
                />
                <span className={`${styles.rs}`}>&#8377;</span>
              </div>
            </div>
          )}
          <Button className="link-btn" disableRipple onClick={handleExpandAll}>
            Expand All
          </Button>
          <span className='divider'></span>
          <Button className='link-btn' disableRipple onClick={handleCollapseAll}>
            Collapse All
          </Button>
          <span className="divider"></span>
          <button onClick={() => handleExport()} className="cmenu-btn">
            <IconExport /> Export
          </button>
          <Button className="primary-btn btn-right ml-16" onClick={() => setOpenPublishModal((prev) => !prev)} disabled={disableRequisition} disableRipple >
            Submit
          </Button>
          {(reduxLoading || loading) && <Loader />}
          {openPublishModal && (
            <InfoModal
              open={openPublishModal}
              handleClose={() => setOpenPublishModal((prev) => !prev)}
              handleOk={handleSubmit}
              title="Submit"
              description="All changes will be submitted. Are you sure you want to submit the entire menu?"
              closeText="No"
              submitText="Yes"
            />
          )}
        </div>
      </div>
      <div className="inner-contant kitchen-dashboard">
        <ListData
          handleToggle={handleToggle}
          openIndices={openIndices}
          searchtext={debouncedSearch}
          onDaypartRowsChange={(daypartcode: any, rows: any[]) => {
            setLocalDaypartRows(prev => ({ ...prev, [daypartcode]: rows }));
          }}
        />
      </div>
    </div>
  );
};

export default ExceptionalMenuRequisitionDetails;
